module.exports = __webpack_public_path__ + "img/UOB.aea642cf.png";